// Simple feature flag check for feature flags page
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the feature flags page
  if (document.querySelector('.feature-flags-dashboard')) {
    // Wait a bit for feature flags to load
    setTimeout(() => {
      try {
        // Check if bag_refresh feature flag is enabled
        if (typeof window.isFeatureEnabled === 'function') {
          const isEnabled = window.isFeatureEnabled('bag_refresh');
          if (isEnabled) {
            // Show simple confirmation dialog
            if (confirm('The bag_refresh feature flag is set to true. Are you sure you want to continue?')) {
              console.log('User confirmed feature flag is enabled');
            } else {
              console.log('User cancelled due to feature flag');
            }
          }
        }
      } catch (error) {
        console.error('Error checking feature flag:', error);
      }
    }, 1000);
  }
});
